import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { ListUser } from "models/list-user";
import { Fragment, FunctionComponent } from "react";
import { useList } from "stores/hooks/list";
import { faPlus } from "components/icon-library";
import { timestamp } from "lib/date";
import { adminDoPatchListUser } from "services/admin/list-user";

interface ArchivedUsersTableProps {
  users: ListUser[];
  onUpdate: () => Promise<void>;
}

const ArchivedUsersTable: FunctionComponent<ArchivedUsersTableProps> = ({
  users,
  onUpdate,
}) => {
  const list = useList();

  if (!list) {
    return null;
  }

  // get columns
  const columns: ColumnInterface[] = [
    {
      key: "name",
      header: "Ilmoitusvelvollinen",
      render: (user: ListUser) => {
        const name = [user.firstname, user.lastname].join(" ").trim();
        if (name.length === 0) {
          return user.email;
        }
        return name;
      },
    },
    {
      key: "archived_at",
      header: "Tehtävä päättynyt",
      width: 150,
      render: (user: ListUser) => {
        return timestamp(user.archived_at);
      },
    },
  ];

  const handleUnarchive = async (user: ListUser) => {
    await adminDoPatchListUser(list, user.uuid, { archived: false });
    onUpdate();
  };

  return (
    <Fragment>
      <Table
        name={`list-${list.uuid}-archived-users`}
        columns={columns}
        data={users}
        noItemsText="Ei ilmoitusvelvollisia"
        editers={[
          {
            icon: faPlus,
            onClick: handleUnarchive,
          },
        ]}
      />
    </Fragment>
  );
};

export default ArchivedUsersTable;
